var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcWifiConnectedWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.825 4.389c-6.09-5.853-15.562-5.85-21.65 0-.229.22-.233.592-.012.82L1.34 6.423c.211.217.55.222.77.013 5.016-4.774 12.763-4.775 17.78 0 .22.209.56.204.77-.013l1.177-1.214c.221-.228.217-.6-.012-.82zM11 11.429c-1.215 0-2.2 1.023-2.2 2.285C8.8 14.977 9.785 16 11 16c1.215 0 2.2-1.023 2.2-2.286 0-1.262-.985-2.285-2.2-2.285zm6.967-2.986c-3.962-3.64-9.976-3.636-13.934 0-.237.218-.245.596-.02.827l1.184 1.214c.207.211.539.226.758.028 2.886-2.591 7.21-2.586 10.09 0 .219.198.55.184.757-.028l1.184-1.214c.226-.23.218-.61-.02-.827z",
    transform: "translate(-345 -573) translate(97 375) translate(16 82) translate(232 116) translate(1 4)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWifiConnectedWhite);
export default __webpack_public_path__ + "static/media/ic-wifi-connected-white.efb376c92e15d39e3ed26df339557926.svg";
export { ForwardRef as ReactComponent };